import request from '@/utils/request'

const urlPrefix = '/log-triggers'

export function getLogTrigger (id) {
  return request.get(`${urlPrefix}/${id}`)
}

export function updateLogTrigger (id, data) {
  return request.put(`${urlPrefix}/${id}`, data)
}

export function deleteLogTrigger (id) {
  return request.delete(`${urlPrefix}/${id}`)
}

export function getLogTriggerList (params) {
  return request.get(urlPrefix, { params })
}

export function createLogTrigger (data) {
  return request.post(urlPrefix, data)
}
